/**
 * The one published clip the marketing surfaces depict, in one place.
 *
 * The hero panel and the Spotlight list both sold this slug as "AI agent tools
 * / 6 links" long after the CMS had republished it as "Graph engineering agents
 * / 8 sources" (#277). Two copies of the same claim drifted independently, so
 * there is now one, and `featuredClip.test.ts` pins every field to a captured
 * response from `cms.manticscore.com` rather than to somebody's memory.
 *
 * Static rather than fetched on purpose: the hero must render identically for
 * every visitor and never depend on the CMS being reachable. The clip PAGE is
 * already live-driven end to end — `api/clip-og.ts` fetches this slug from the
 * CMS and `buildClipMeta` derives og/twitter meta from that payload — so
 * nothing here feeds meta. This is the fallback copy that has to agree with it.
 *
 * Refresh it from the live payload, never by hand:
 *   curl -s https://cms.manticscore.com/api/v1/clips/s-24a62a24fbfc3bf2
 */
export const FEATURED_CLIP = {
  slug: "s-24a62a24fbfc3bf2",
  /** CMS `title`, which is also `research.session.title` — the string
   * `buildClipMeta` puts in og:title. */
  title: "Graph engineering agents",
  /** CMS `description`, which is also `research.session.intent_summary` — the
   * string that lands in og:description. */
  description:
    "Exploring how graph-based agent architectures are replacing manual prompting for autonomous work",
  /** `research.session.total_links`. The hero block's subheading states the
   * same number in words, so the two cannot be allowed to disagree. */
  sourceCount: 8,
  /** The clip's own hero subheading, verbatim. */
  heroSubheading: "8 sources, one thread",
  /** The first content card a reader actually sees on the page, so the panel
   * previews the clip instead of a plausible-looking imitation of one. */
  firstCard: {
    title: "Sam Altman on Prompting",
    summary: "OpenAI CEO Sam Altman explains how to use ChatGPT better than most people do.",
  },
  firstQuote: {
    body: "You don't need to write prompts anymore.",
    author: "Altman's Prediction",
  },
  firstCta: {
    heading: "Watch the Thread",
    buttonLabel: "View on X",
  },
} as const;
